import { Outlet } from 'react-router'

const FleetLayout = () => {
  return (
    <Outlet />
  )
}

export default FleetLayout